export const IDMEUSERDATA_LOADING = 'REDUX_SAGA_IDMEUSERDATA_LOADING';
export const GET_IDMEUSERDATA_DATA_SUCCESS = 'REDUX_SAGA_GET_IDMEUSERDATA_DATA_SUCCESS';
export const GET_IDMEUSERDATA_DATA_ERROR = 'REDUX_SAGA_GET_IDMEUSERDATA_DATA_ERROR';
export const IDMEUSERDATA_END_LOADING = 'REDUX_SAGA_IDMEUSERDATA_END_LOADING';
export const RESET_IDMEUSERDATA = 'REDUX_SAGA_RESET_IDMEUSERDATA';

export const actionGetIDMEUSERDATA = (dispatch, token) => {
    dispatch({
        type: IDMEUSERDATA_LOADING, payload:
            { token: token }
    })
};

export const actionResetIDMEUSERDATA = (dispatch) => {
    dispatch({ type: RESET_IDMEUSERDATA })
}